// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2w2Nn","container":"styles_container__1tioK","title":"styles_title__3cCXP","wrapper":"styles_wrapper__1wUOJ","answer":"styles_answer__35xAc"};